import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditCourseRecord from '../EditCourseRecord';
import SingleCourseRecord from '../SingleCourseRecord';

const useStyles = makeStyles((theme) => ({
  recordsListContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 650
  },
  boldText: {
    fontWeight: 800
  },
  deleteIcon: {
    color: theme.palette.danger.minor
  },
  cancelButton: {
    marginLeft: 10,
    color: theme.palette.subTitle.main
  }
}));

const RecordsList = (props) => {
  const classes = useStyles();
  const {
    records,
    handleDeleteCourseRecordClick,
    userId,
    personnels,
    enableEditCourseRecord,
    isEditRecordEnabled,
    recordBeingEdited,
    handleEditCourseRecordInputChange,
    handleSaveCourseRecordClick,
    fetchAllPersonnels,
    branchId,
    handleRemoveAttachment,
    allAttachments
  } = props;

  React.useEffect(() => {
    if (personnels.length === 0) {
      fetchAllPersonnels(branchId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableContainer component={Paper} className={classes.recordsListContainer}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.boldText}>Personnel</TableCell>
            <TableCell className={classes.boldText}>Date</TableCell>
            <TableCell className={classes.boldText}>Expires</TableCell>
            <TableCell className={classes.boldText}>Notes</TableCell>
            <TableCell className={classes.boldText} align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record) => {
            const isEditMode =
              isEditRecordEnabled && record.id === recordBeingEdited.id;

            return (
              <TableRow key={record.id}>
                {isEditMode ? (
                  <EditCourseRecord
                    record={recordBeingEdited}
                    handleEditCourseRecordInputChange={
                      handleEditCourseRecordInputChange
                    }
                    personnels={personnels}
                    enableEditCourseRecord={enableEditCourseRecord}
                    handleSaveCourseRecordClick={handleSaveCourseRecordClick}
                    allAttachments={allAttachments}
                    handleRemoveAttachment={handleRemoveAttachment}
                  />
                ) : (
                  <SingleCourseRecord
                    record={record}
                    userId={userId}
                    personnels={personnels}
                    handleDeleteCourseRecordClick={
                      handleDeleteCourseRecordClick
                    }
                    enableEditCourseRecord={enableEditCourseRecord}
                  />
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecordsList;
